import { Selector } from '../StoreConfig';
import { ToDoList } from './types';

export const selectToDoList: Selector<ToDoList> = (state) => {
  return state.toDoList;
};
